module.exports = __webpack_public_path__ + "img/maestro.0cf07e33.svg";